import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';

//redux
import ReceptionGuide from './ReceptionGuide/ReceptionGuide';

const FinalDestinationReception = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '#', label: 'Medio Ambiente' },
		{ to: '/residue/dashboard', label: 'Residuos' },
		{ to: '#', label: 'Destino Final' }
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Recepcionar guías' links={breadcrumbLinks} />
					<ReceptionGuide/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default FinalDestinationReception;